import { useCallback } from "react";
import { Table, Text, Switch, ActionIcon, Tooltip } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

interface EligibilityRowProps {
  rowKey: string;
  insuranceProviderName: string | null;
  insuranceProviderId: string | null;
  isCatchAll: boolean;
  tcpcEligible: boolean;
  disabled: boolean;
  onToggle: (rowKey: string) => void;
  onRemove: (rowKey: string) => void;
}

export default function EligibilityRow({
  rowKey,
  insuranceProviderName,
  insuranceProviderId,
  isCatchAll,
  tcpcEligible,
  disabled,
  onToggle,
  onRemove,
}: EligibilityRowProps) {
  const handleToggle = useCallback(() => onToggle(rowKey), [rowKey, onToggle]);
  const handleRemove = useCallback(() => onRemove(rowKey), [rowKey, onRemove]);

  const label = isCatchAll
    ? "All other carriers"
    : insuranceProviderName ?? insuranceProviderId ?? "—";

  return (
    <Table.Tr
      style={
        isCatchAll
          ? { backgroundColor: "var(--mantine-color-gray-0)" }
          : undefined
      }
    >
      <Table.Td>
        <Text
          size="sm"
          fw={isCatchAll ? 500 : undefined}
          c={isCatchAll ? "dimmed" : undefined}
        >
          {label}
        </Text>
      </Table.Td>
      <Table.Td>
        <Switch
          checked={tcpcEligible}
          onChange={handleToggle}
          disabled={disabled}
          color={tcpcEligible ? "green" : "red"}
          label={tcpcEligible ? "Eligible" : "Not Eligible"}
        />
      </Table.Td>
      <Table.Td>
        <Tooltip label="Remove rule">
          <ActionIcon
            color="red"
            variant="subtle"
            onClick={handleRemove}
            disabled={disabled}
            aria-label={`Remove eligibility rule for ${label}`}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Tooltip>
      </Table.Td>
    </Table.Tr>
  );
}
